import { Injectable, signal } from '@angular/core';
import { UIStore } from 'src/app/stores/ui.store';

@Injectable({
  providedIn: 'root',
})
export class UIService {
  public currentMenu = signal<string>('CAReS');

  public refreshList(searchFilter: string): void {
    UIStore.onRefreshList.emit(searchFilter);
  }

  public hideSidebar(): void {
    UIStore.onSidebar.emit();
  }
}
